import Linkedin from "../../assets/icons/linkedIn.svg";
import { motion } from "framer-motion";

export default function Card({ pfp, name, position, linkedin, isArdi }) {
  return (
    <motion.div
      className="team-card"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
      viewport={{ once: true, amount: 0.2 }}
    >
      <div className={`team-card-image ${isArdi && "team-card-image-ardi"}`}>
        <img
          className="pointer transition team-card-pfp"
          src={pfp}
          alt={name}
        />
        <div className="team-card-socials bg-white">
          <a href={linkedin}>
            <img src={Linkedin} alt="Linkedin Icon" />
          </a>
        </div>
      </div>
      <div className="team-card-content">
        <h3 className="clr-white fs-400 ">{name}</h3>
        <h4 className="clr-blue fs-200">{position}</h4>
      </div>
    </motion.div>
  );
}
